export interface SocketConnectionAtom {
  [key: string]: boolean;
}

export enum SocketConnectionReducerActionTypes {
  CONNECTION = 'CONNECTION',
}

export enum SocketName {
  CONVERSATION = 'conversation',
  // ORGANIZATION = 'organization',
  // USER = 'user',
}

interface ConnectionAction {
  type: SocketConnectionReducerActionTypes.CONNECTION;
  data: {
    name: string;
    status: boolean;
  };
}

export type SocketConnectionReducerAction = ConnectionAction;

export interface FallbackSyncController {
  enabled: boolean;
  start: () => void;
  stop: () => void;
}
